
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as dashboard9SJMqcevvF50LyOVEf9BpdDC4GfV4QB4BvCYrOEEN0sMeta } from "/builds/hotelschool-the-hague/narrowcasting/app/pages/dashboard.vue?macro=true";
import { default as indexbwMk1e3H2hFPxO11ObfhTELAvEvfGCLTb4tli_2WBGAMeta } from "/builds/hotelschool-the-hague/narrowcasting/app/pages/index.vue?macro=true";
export default [
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboard9SJMqcevvF50LyOVEf9BpdDC4GfV4QB4BvCYrOEEN0sMeta || {},
    component: () => import("/builds/hotelschool-the-hague/narrowcasting/app/pages/dashboard.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/builds/hotelschool-the-hague/narrowcasting/app/pages/[...slug].vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexbwMk1e3H2hFPxO11ObfhTELAvEvfGCLTb4tli_2WBGAMeta || {},
    component: () => import("/builds/hotelschool-the-hague/narrowcasting/app/pages/index.vue")
  }
]